import { TravelExpensesStatusEnum } from '../../types/enums/affected-staff/affected-staff-status.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { TravelExpensesStaffsFilters } from '../../types/models/travel-expenses/travel-expenses-staff'

export const defaultTravelExpensesStaffStatuses: TravelExpensesStatusEnum[] = [
  TravelExpensesStatusEnum.RECEIVED,
  TravelExpensesStatusEnum.VALIDATED
]

export const transformTravelExpensesStaffFiltersToUrl = (
  filters?: TravelExpensesStaffsFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.travelExpensesStatuses && filters.travelExpensesStatuses.length)
    searchParams.append('travelExpensesStatuses', filters.travelExpensesStatuses.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  if (filters.positions && filters.positions.length)
    searchParams.append('positions', filters.positions.join(','))

  return searchParams.toString()
}

export const transformUrlToTravelExpensesStaffFilters = (
  searchParams: URLSearchParams
): TravelExpensesStaffsFilters => {
  const filters: TravelExpensesStaffsFilters = {}

  const travelExpensesStatuses = searchParams.get('travelExpensesStatuses')
  if (travelExpensesStatuses && travelExpensesStatuses.length)
    filters.travelExpensesStatuses = travelExpensesStatuses.split(
      ','
    ) as TravelExpensesStatusEnum[]
  else filters.travelExpensesStatuses = [TravelExpensesStatusEnum.RECEIVED]

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',').map((id) => parseInt(id))

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const positions = searchParams.get('positions')
  if (positions && positions.length)
    filters.positions = positions.split(',') as StaffPositionEnum[]

  return filters
}
